/**
 * FlashcardSkeleton
 *
 * A skeleton loading state for the Flashcard component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface FlashcardSkeletonProps {
  className?: string
}

export const FlashcardSkeleton: React.FC<FlashcardSkeletonProps> = ({ className }) => {
  return (
    <div className={cn('perspective-1000 my-6', className)}>
      <div className="transform-style-3d relative h-[240px] w-full animate-pulse rounded-lg transition-transform duration-500 md:h-[280px]">
        {/* Front side (Question) skeleton */}
        <div className="backface-hidden bg-card absolute size-full rounded-lg border p-6 shadow-sm">
          <div className="flex h-full flex-col">
            {/* Question title skeleton */}
            <div className="mb-2 flex items-center">
              <div className="h-4 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>

            {/* Question content skeleton */}
            <div className="flex-1 space-y-2">
              <div className="h-4 w-3/4 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 w-5/6 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>

            {/* Controls skeleton */}
            <div className="mt-4 flex justify-between">
              <div className="h-8 w-20 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="size-8 rounded-full bg-gray-200 dark:bg-gray-700"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
